<template>
    <div class="checkout-basket">
        <CheckoutBasketHeader />
        <div
            v-for="item in products"
            :key="item.offer && item.offer.id || item.id"
            class="notAvailable-1c"
        >
            <CheckoutBasketProduct
                :result="item"
                :class="{ 'notAvailable-1c__product': !item.isAvailableIn1C }"
            />
            <p
                v-if="!item.isAvailableIn1C"
                class="notAvailable-1c__message"
            >
                {{ messages.notAvailableIn1C }}
                <DefLink :href="messages.editOrder.LINK">
                    {{ messages.edit }}
                </DefLink>
            </p>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CheckoutBasketHeader from "./CheckoutBasketHeader";
import CheckoutBasketProduct from "./CheckoutBasketProduct";
import DefLink from "../../def/DefLink/DefLink";

export default {
    name: 'CheckoutBasket',
    components: {
        CheckoutBasketHeader,
        CheckoutBasketProduct,
        DefLink,
    },
    computed: {
        ...mapState({
            products: ({ checkout }) => checkout.data.vue.products,
            messages: ({ checkout }) => checkout?.data?.vue?.messages,
        })
    },
    methods: {
        ...mapMutations({
            changeOpenSmallBasket: 'basket/changeOpenSmallBasket',
        }),
    },
}
</script>

<style lang="scss" scoped>
.checkout-basket{
    background-color: #fff;
    padding: 16px;
    @include point-md{
        padding: 24px;
    }
}
.notAvailable-1c{
    position: relative;
    &:not(:last-child) {
        margin-bottom: 4px;
    }
    &__product{
        opacity: .6;
    }
    &__message{
        position: absolute;
        bottom: 0;
        right: 0;
        color: var(--color-red);
        padding:  5px 10px;
        background-color: rgba(255, 255, 255, 1);
        font-size: rem(12);
    }
    :deep(.def-link){
        color: var(--color-red);
    }
}
</style>